<template lang='pug'>
  .header
    component(:is='type' :member='this.currentUser')
</template>

<script>
import GuestHeader from './guest-header.vue'
import MemberHeader from './member-header.vue'

export default {
  name: 'Header',

  components: {
    guest: GuestHeader,
    member: MemberHeader
  },

  props: {
    currentUser: Object
  },

  computed: {
    type () {
      return this.currentUser ? 'member' : 'guest'
    }
  }
}
</script>
